<template>
  <div>
    <JcdcLoadingPage v-if="$store.state.etar.loadingPage" />
    <div v-else>
      <div v-if="unsignedEtars" class="mb-4">
        <JcdcBadge
          :color="badgeColor"
          content="#"
          style="position: relative; top: -6px; margin-left: -6px"
        />
        Indicates the number of unacknowledged E-TAR ratings.<br />
        <span class="text-body-2">
          To acknowledge E-TARs, click the the associated check box in each row.
          Click the "Save Changes" button when complete.
        </span>
      </div>
      <JcdcTabs :vertical="!mobile" class="etarTabs">
        <!-- Tabs -->
        <JcdcTabHeader v-if="!mobile" :level="1">Records</JcdcTabHeader>
        <v-tab
          v-for="item in etarList"
          :key="item.tarId"
          class="justify-start text-left py-3"
          active-class="primary white--text"
          :to="{
            name: 'EtarTable',
            params: {
              etarDetId: item.enrTarId,
            },
          }"
        >
          <JcdcBadge
            v-if="alumniUser"
            :color="badgeColor"
            icon="$complete"
            :value="item.tarStatus == 'Completer'"
          >
            {{ item.tarDesc }}
          </JcdcBadge>
          <JcdcBadge
            v-else
            :color="badgeColor"
            :content="unsignedEtarCount(item)"
            :value="unsignedEtarCount(item) > 0"
          >
            {{ item.tarDesc }}
          </JcdcBadge>
        </v-tab>
        <div v-if="!mobile" class="stickyLegend">
          <JcdcRatingsKey
            :items="ratingsData"
            :length="3"
            class="mr-4 my-8"
            title="Ratings Key"
            vertical
          />
          <JcdcBtn
            v-if="!alumniUser"
            :loading="loadingTable"
            icon="mdi-content-save"
            icon-right
            :disabled="!edited"
            small
            @click="saveTable()"
          >
            Save Changes
          </JcdcBtn>
        </div>
        <!-- Tab Items -->
        <v-tabs-items>
          <v-card flat>
            <v-card-text>
              <router-view />
            </v-card-text>
          </v-card>
        </v-tabs-items>
      </JcdcTabs>
    </div>
  </div>
</template>
<script>
// JCDC Components
import { mapActions, mapState } from 'vuex'
import {
  JcdcBadge,
  JcdcBtn,
  JcdcLoadingPage,
  JcdcRatingsKey,
  JcdcTabHeader,
  JcdcTabs,
} from '@/components/jcdc/index'

export default {
  name: 'EtarPage',
  components: {
    JcdcBadge,
    JcdcBtn,
    JcdcLoadingPage,
    JcdcRatingsKey,
    JcdcTabHeader,
    JcdcTabs,
  },
  data() {
    return {
      alumniUser: this.$store.state.userInfo.userRole.includes(3),
      badgeColor: 'accent',
      unsignedEtars: false,
      ratingsData: [
        {
          descriptions: [
            {
              rating: 3,
              text: 'Proficient and able to teach others',
            },
            {
              rating: 2,
              text: 'Proficient',
            },
            {
              rating: 1,
              text: 'Exposed / Not Proficient',
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapState('etar', [
      'etarList',
      'currentEtar',
      'currentEtarIndex',
      'edited',
      'loadingTable',
    ]),
    mobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  watch: {
    // When the user double clicks on the nav link, they get a blank tab. This code fixes that. It also maintains the previous selection as the user navigates around the site. -MN
    $route(val) {
      if (val.fullPath == '/e-tar') this.updateRoute()
    },
  },
  mounted() {
    if (this.$route.fullPath == '/e-tar') this.updateRoute()
  },
  methods: {
    ...mapActions('etar', ['saveTable']),
    updateRoute() {
      this.$router.replace({
        name: 'EtarTable',
        params: {
          etarDetId: this.currentEtar.enrTarId,
        },
      })
    },
    unsignedEtarCount(item) {
      const count = item.nbrItemsStaffSignoff - item.nbrItemsStudSignoff
      if (count > 0) this.unsignedEtars = true
      return count
    },
  },
}
</script>
<style lang="scss">
// DESKTOP ONLY
.etarTabs {
  &.v-tabs--vertical {
    .v-tabs-bar .v-tabs-bar__content {
      max-width: 325px;
    }
  }
  .v-tabs-bar .v-tabs-bar__content {
    text-wrap: balance;
    .v-tab .v-badge__wrapper {
      margin: 0 0 0 10px;
    }
  }
  .v-slide-group__wrapper {
    overflow: visible;
    .stickyLegend {
      min-width: 300px;
      position: sticky;
      position: -webkit-sticky;
      top: 50px; /* required */
      align-self: flex-start; /* <-- this is the fix */
    }
  }
}
</style>
